// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__MdaY9","modalOpen":"styles_modalOpen___hc5D","closerOverlay":"styles_closerOverlay__r82Q8","modal":"styles_modal__QAAcF","close":"styles_close__JA_3r"};